import { REACT_APP_FUNCTIONS_URL } from "../../constants/env";

const API_ADMIN_URL = `${REACT_APP_FUNCTIONS_URL}/api/admin/resources`;
const API_ERROR = "Une erreur est survenue, veuillez réessayer ultérieurement.";

const fetchResources = async (token) => {
  let error;

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
  };

  const res = await fetch(API_ADMIN_URL, options)

  if (!res.ok) {
    error = API_ERROR;
  }

  const resources = await res.json();

  return { resources, error };
}

export default {
  fetchResources
}



// WEBPACK FOOTER //
// ./src/services/api/admin.js